import { Button } from "components/DesignSystem/Button/Button";
import { FeatureDetails } from "components/FeatureDetails/FeatureDetails";
import { REGISTERED_AGENT } from "constants/addons";
import { SOMETHING_WENT_WRONG } from "constants/apiCallError";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useToast } from "hooks/useToast";
import {
  LockDescription,
  LockFeatures,
} from "pages/Books/RevenueMetrics/RevenueMetricsLocked";
import { useDispatch } from "react-redux";
import { useLazyGetSubscriptionsQuery } from "store/apis/subscriptions";
import { setAddonData, setAddonType } from "store/slices/addons";
import MailRoomIndex from "static/images/MailRoomIndex.webp";

export const LockedRegisterAgent = () => {
  const dispatch = useDispatch();

  const { uuid: groupId } = useCurrentGroupContext();
  const [getRegisteredAgentAddon] = useLazyGetSubscriptionsQuery();
  const { alertToast } = useToast();

  const handleNotRegisteredAgent = async () => {
    try {
      const resp = await getRegisteredAgentAddon({
        subscription_types: REGISTERED_AGENT,
        groupId,
      }).unwrap();
      const registeredAgentUnselectedStates = resp
        ?.filter((ele) => !ele.group_subscription)
        ?.map((ele) => {
          return {
            amount: ele?.amount,
            type: ele?.metadata?.ra_state,
            uuid: ele?.uuid,
          };
        });

      dispatch(
        setAddonData({
          ...resp[0],
          unselectedStates: registeredAgentUnselectedStates,
        })
      );
      dispatch(setAddonType(REGISTERED_AGENT));
    } catch (error: any) {
      alertToast({
        message: error?.message || SOMETHING_WENT_WRONG,
      });
    }
  };

  const featureDetails = [
    {
      type: "usaPin",
      description: "Choose a Registered Agent in any state",
    },
    {
      type: "divider",
      description: "",
    },
    {
      type: "complienceClipboard",
      description: "Stay on top of all your compliance and notices",
    },
    {
      type: "divider",
      description: "",
    },
    {
      type: "dashboardMonitor",
      description: "Keep track of all your RAs in one simple dashboard",
    },
  ];
  const descriptionText =
    "Register and manage your registered agents across all US states";
  return (
    <section className="t-flex t-justify-center t-items-center t-w-full t-h-full">
      <FeatureDetails
        banner={
          <img
            className="t-w-[22.5625rem] t-h-[13.5rem] t-object-cover"
            src={MailRoomIndex}
            alt="Registered Agent"
          />
        }
        description={
          <LockDescription
            descriptionText={descriptionText}
            title="Registered Agent"
          />
        }
        feature={
          <div className="t-flex t-gap-5 t-w-[31.8125rem] sm:t-w-full sm:t-flex-col sm:t-gap-4 sm:t-max-h-none sm:t-h-auto t-h-[82px] t-mx-auto t-items-center">
            {featureDetails.map((feature, index) => (
              <LockFeatures
                key={index}
                type={feature.type}
                description={feature.description}
              />
            ))}
          </div>
        }
        button={
          <Button
            onClick={handleNotRegisteredAgent}
            customType="primary"
            size="regular"
          >
            Get Started
          </Button>
        }
      />
    </section>
  );
};
